import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatabaseDownstreamWorkbooksFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamWorkbooksFilteredByTableQuery(
  $databaseId: ID!,
  $tableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  databases(filter: { id: $databaseId }) {
    tables(filter: { id: $tableId }) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          containerName
          containerType
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
`;
